import React from "react";
import { useHistory } from "react-router-dom";

const Notfound = () => {
  const history = useHistory();
  return (
    <div
      className="text-center w-100 "
      style={{ marginTop: "calc(13%)", color: "rgba(0,0,0,0.6)" }}
    >
      <img
        alt=""
        src={require("../assets/images/500Error.png")}
        style={{ width: "27%" }}
      />
      <h4 className="mb-0 mt-4">
        Oops!
        <br /> Something went wrong
      </h4>
      <p className="mt-1 mb-4">Please try reloading the site</p>
      <button
        className="btn btn-primary"
        onClick={(e) => history.push("/inspection")}
      >
        Go back
      </button>
    </div>
  );
};

export default Notfound;
